import { useTranslation } from 'react-i18next';
import { settingSVG } from '../../lib/allCustomSVGs';
import MainSquareButton from '../../ui/buttons/MainSquareButton';
import CustomSVGs from '../../ui/customSVGs/CustomSVGs';
import IconSelectInput from '../../ui/inputs/IconSelectInput';
import { useState } from 'react';
import ToggleSwitch from '../../ui/buttons/ToggleSwitch';
import AIURLInput from '../../ui/inputs/AIURLInput';
import removeHttpPrefix from '../../lib/helper-functions/removeHttpPrefix';
import ValueSelector from '../../ui/inputs/ValueSelector';

type Props = {
  toggleSettingsPopupModal: (isOpen: boolean) => void;
};

const AIOptimizationsGlobalSettingsCard = ({
  toggleSettingsPopupModal,
}: Props) => {
  const { t } = useTranslation();
  const [cmsType, setCMSType] = useState('custom');
  const [websiteURL, setWebsiteURL] = useState('');
  const [enableTracking, setEnableTracking] = useState(false);
  const percentagesArr = Array.from({ length: 10 }, (_, index) => {
    return {
      label: (index + 1)?.toString(),
      value: (index + 1) * 10,
    };
  });
  const [optimizeValue, setOptimizeValue] = useState(80);
  return (
    <div className='aiOptimizationsGlobalSettingsCard'>
      <div className='aiOptimizationsGlobalSettingsCard__title'>
        <CustomSVGs svg={settingSVG} />
        <h3>{t('GlobalA/B-TestingSettings')}</h3>
      </div>

      <div className='aiOptimizationsGlobalSettingsCard__switch'>
        <h3>{t('EnableTracking')}</h3>
        <ToggleSwitch
          isOn={enableTracking}
          onClick={() => setEnableTracking(!enableTracking)}
          disabled={false}
        />
      </div>

      <h3 className='aiOptimizationsGlobalSettingsCard__title'>
        {t('ConfigureYourWebshopIntegrations')}
      </h3>

      <div className='aiOptimizationsGlobalSettingsCard__inputs'>
        <div className='aiOptimizationsGlobalSettingsCard__inputs--content'>
          <div className='aiOptimizationsGlobalSettingsCard__inputs--content-1'>
            <AIURLInput
              id='ebsite-url'
              value={websiteURL}
              label={t('WebsiteURL')}
              placeholder={t('your-website.com')}
              changeListeners={[
                (e) => {
                  setWebsiteURL(removeHttpPrefix(e.target.value));
                },
              ]}
              prefix={'https://'}
              title={t('URL-validation')}
              required={true}
            />
          </div>
          <div className='aiOptimizationsGlobalSettingsCard__inputs--content-2'>
            <IconSelectInput
              filterOptions={[
                { text: t('Custom'), value: 'custom', icon: null },
                { text: t('Shopify'), value: 'shopify', icon: null },
                { text: t('WooCommerce'), value: 'woocommerce', icon: null },
                { text: t('Magento'), value: 'magento', icon: null },
              ]}
              title={t('ConfidenceLevel(%)')}
              value={cmsType}
              onFilterChange={(val) => setCMSType(val)}
              marginTop='1.5rem'
              scrollWhenOpen={true} // ✅ Enable scroll into view when dropdown opens
            />
          </div>
        </div>

        <h3 className='aiOptimizationsGlobalSettingsCard__title'>
          {t('OptimizationRatio')}
        </h3>
        <div className='aiOptimizationsGlobalSettingsCard__message'>
          {t('OptimizationRatioMsg')}
        </div>
        <div className='aiOptimizationsGlobalSettingsCard__inputs--contentLong'>
          <ValueSelector
            onChange={setOptimizeValue}
            value={optimizeValue}
            loading={false}
            isEqualSignVisible={true}
            symbol={'%'}
            content={percentagesArr}
          />
        </div>
      </div>

      <div className='aiOptimizationsGlobalSettingsCard__buttons'>
        <MainSquareButton
          value={t('Cancel')}
          type='button'
          buttonType='white'
          disabled={false}
          onClick={() => toggleSettingsPopupModal(false)}
        />
        <MainSquareButton
          value={t('UpdateSetup')}
          type='button'
          disabled={false}
          onClick={() => {}}
        />
      </div>
    </div>
  );
};

export default AIOptimizationsGlobalSettingsCard;
